import { put, select } from "@redux-saga/core/effects";
import { getGoogleSheetWorksheetsFailure, getGoogleSheetWorksheetsSuccess } from "../actionCreators";
import { GetGoogleSheetWorksheetsRequestActionType } from "../types";
import { IntegrationService } from "../integration.service";

export function* getGoogleSheetWorksheetsSaga(action: GetGoogleSheetWorksheetsRequestActionType) {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { sheetId } = action.payload;

        const { data } = yield IntegrationService.getGoogleSheetsWorksheets(formId, sheetId);

        yield put(getGoogleSheetWorksheetsSuccess({ success: true, message: "", worksheets: data.data }));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to fetch Google Sheets worksheets";

        yield put(getGoogleSheetWorksheetsFailure(errorMessage));
    }
}
